import { render, staticRenderFns } from "./IconEntity.vue?vue&type=template&id=f0d4eb80&"
import script from "./IconEntity.vue?vue&type=script&lang=ts&"
export * from "./IconEntity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports